export const ETHNICITY_OPTIONS = [
  { value: 'AfricanAmerican', label: 'African American' },
  { value: 'Asian', label: 'East Asian' },
  { value: 'SouthAsian', label: 'South Asian' },
  { value: 'Caucasian', label: 'Caucasian' },
  { value: 'Hispanic', label: 'Hispanic' },
  { value: 'Indigenous', label: 'Indigenous' },
  { value: 'MiddleEastern', label: 'Middle Eastern' },
  { value: 'PacificIslander', label: 'Pacific Islander' },
  { value: 'Mixed', label: 'Mixed Heritage' },
  { value: 'Ambiguous', label: 'Ethnically Ambiguous' }
];